export const ANALYTICS_SALES_QUERY_KEY = 'analytics-sales';
export const ANALYTICS_TRANSACTIONS_QUERY_KEY = 'analytics-transactions';
export const ANALYTICS_PRODUCTS_QUERY_KEY = 'analytics-products';
export const ANALYTICS_CUSTOMERS_QUERY_KEY = 'analytics-customers';
export const ANALYTICS_DASHBOARD_QUERY_KEY = 'analytics-dashboard';
export const ANALYTICS_RECENT_CHATS_QUERY_KEY = 'analytics-recent-chats';
